import { SvgIconType } from './svg.interface';

const CaretUp: SvgIconType = ({
  width = 16,
  height = 16,
  className = '',
  color = '#30313D'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7088 10.311C15.3309 10.9343 14.8903 12 14.0104 12L1.98959 12C1.10972 12 0.669083 10.9343 1.29125 10.311L7.30165 4.28979C7.68734 3.9034 8.31266 3.9034 8.69835 4.28978L14.7088 10.311Z"
      fill={color}
    />
  </svg>
);

export default CaretUp;
